module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kWUeJ"))).then(() => parcelRequire('hEqeo'));